import React from 'react';

const SurveyNumberStepper = ({ value, onChange, min = 0, max = 7, compact = false }) => {
  const n = Math.min(max, Math.max(min, Number(value) || 0));
  const gap = compact ? 'gap-1.5' : 'gap-2';
  const btn = compact
    ? 'w-8 h-8 rounded-md border border-input bg-transparent hover:bg-muted text-sm font-semibold disabled:opacity-40 disabled:hover:bg-transparent shrink-0'
    : 'w-10 h-10 rounded-lg border border-input bg-transparent hover:bg-muted text-lg font-semibold disabled:opacity-40 disabled:hover:bg-transparent';
  const center = compact
    ? 'w-8 flex items-center justify-center font-display text-lg tabular-nums shrink-0'
    : 'flex-1 h-10 rounded-lg border border-input bg-background flex items-center justify-center font-display text-2xl tabular-nums';
  return (
    <div className={`flex items-center ${gap}`}>
      <button type='button' onClick={() => onChange(Math.max(min, n - 1))} disabled={n <= min} className={btn}>
        −
      </button>
      <div className={center}>{n}</div>
      <button type='button' onClick={() => onChange(Math.min(max, n + 1))} disabled={n >= max} className={btn}>
        +
      </button>
    </div>
  );
};

export default SurveyNumberStepper;
